//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import React from 'react';
import styled from 'styled-components';

import Icon from '@components/atoms/icon/Icon';
import {
  FACEBOOK_ICON_COLOR,
  PINTEREST_ICON_COLOR,
  TIKTOK_ICON_COLOR,
  TWITTER_ICON_COLOR,
  YOUTUBE_RED_ICON_COLOR,
} from '@components/atoms/icon/iconConstants';
import igSvgIcon from '@images/instagram.svg';
import { SocialNetwork } from '@models/SocialNetwork';
import { isDefined } from '@utils/filterPredicates';

interface Props {
  socialNetwork?: SocialNetwork;
  size?: number;
  className?: string;
}

export const SocialNetworkIcon = ({
  className,
  size,
  socialNetwork,
}: Props) => {
  switch (socialNetwork) {
    case SocialNetwork.Instagram:
      return <InstagramIcon className={className} size={size} />;
    case SocialNetwork.Facebook:
      return <FacebookIcon className={className} size={size} />;
    case SocialNetwork.TikTok:
      return <TikTokIcon className={className} size={size} />;
    case SocialNetwork.Pinterest:
      return <PinterestIcon className={className} size={size} />;
    case SocialNetwork.Twitter:
      return <TwitterIcon className={className} size={size} />;
    case SocialNetwork.YouTube:
      return <YouTubeIcon className={className} size={size} />;
    case SocialNetwork.Bazaarvoice:
      return <BazaarvoiceIcon className={className} size={size} />;
    default:
      return <></>;
  }
};

export const InstagramIcon = styled.img.attrs({ src: igSvgIcon })<{
  size?: number;
}>(
  ({ size }) => `
  ${isDefined(size) ? `width: ${size}px; height: ${size}px;` : ''}
`,
);

const NetworkIcon = styled(Icon)<{ size?: number }>(
  ({ size }) => `
  ${isDefined(size) ? `width: ${size}px; height: ${size}px;` : ''}
`,
);

export const FacebookIcon = styled(NetworkIcon).attrs({
  name: 'facebook',
})`
  color: ${FACEBOOK_ICON_COLOR};
`;

export const PinterestIcon = styled(NetworkIcon).attrs({
  name: 'pinterest',
})`
  color: ${PINTEREST_ICON_COLOR};
`;

export const TwitterIcon = styled(NetworkIcon).attrs({
  name: 'twitter',
})`
  color: ${TWITTER_ICON_COLOR};
`;

export const TikTokIcon = styled(NetworkIcon).attrs({
  name: 'tiktok',
})`
  color: ${TIKTOK_ICON_COLOR};
`;

export const YouTubeIcon = styled(NetworkIcon).attrs({
  name: 'youtube',
})`
  color: ${YOUTUBE_RED_ICON_COLOR};
`;

export const BazaarvoiceIcon = styled(NetworkIcon).attrs({
  name: 'bv-logomark',
})`
  color: #002e6e;
`;
